export default __webpack_public_path__ + "427bb4eef9739caa1ebc0aacddb13208.png";